<script>
  import {
    stops,
    stopArrivalTimes,
    mapVehiclePoints,
    routesForMapWithScheduleWithEncodedLine
  } from "../store.js";
  import OnTimeStatus from "../components/OnTimeStatus.svelte";
  import DataTable from "../components/DataTable.svelte";

  export let routeId;

  $: myRoutes = $routesForMapWithScheduleWithEncodedLine.filter(route => {
    return parseInt(route.RouteID) === parseInt(routeId);
  });

  $: myRoute =
    myRoutes.length === 0 ? { Description: "", IsRunning: false } : myRoutes[0];

  // (array) only stops associated with this particular route
  $: myStops = $stops.filter(stop => {
    return parseInt(stop.RouteID) === parseInt(routeId);
  });
  // (array) only stop arrival times associated with this particular route
  $: myArrivalTimes = $stopArrivalTimes.filter(times => {
    return parseInt(times.RouteId) === parseInt(routeId);
  });
  // (array) only Vehicle Points associated with this particular route
  $: myVehiclePoints = $mapVehiclePoints.filter(vehicle => {
    return parseInt(vehicle.RouteID) === parseInt(routeId);
  });

  // (object) The keys are the stopIDs and the values are the Stop Names
  $: stopNames = myStops.reduce((acc, stop) => {
    acc[stop.RouteStopID] = stop.Description;
    return acc;
  }, {});

  // (object) The keys are the vehicleIDs and the values are the Vehicle Names
  $: vehicleNames = myVehiclePoints.reduce((acc, vehicle) => {
    acc[vehicle.VehicleID] = vehicle.Name;
    return acc;
  }, {});
  // (number) The number of vehicles on this route (based on vehicle names results)
  $: numberOfVehiclesVN = Object.keys(vehicleNames).length;
  // (number) The number of vehicles on this route (based on arrival time data)
  $: numberOfVehiclesAT = myArrivalTimes.reduce((totalVehicles, busStop) => {
    // let's see how many bus stop time arrays we get for each bus stop, usually each time array represents a seperate vehicle on the route
    // but first, sometimes the data we get is sloppy and we get two duplicate bus stop time arrays, we should not count the duplicates, so lets remove them
    let vehicleTimes = busStop.Times.reduce((uniqueTimeArray, item) => {
      return uniqueTimeArray.find(x => x.VehicleId === item.VehicleId) !==
        undefined
        ? uniqueTimeArray
        : [...uniqueTimeArray, item];
    }, []);
    // increment the total number of vehicles if there are more bus stop times arrays at this bus stop than other bus stops
    if (vehicleTimes.length > totalVehicles) {
      return vehicleTimes.length;
    } else {
      return totalVehicles;
    }
  }, 0);

  $: columns = { "1": "Bus Stop", ...vehicleNames };
  $: rowData = myArrivalTimes.map(stop => {
    let row = {};
    row["1"] = stopNames[stop.RouteStopId];
    stop.Times.forEach(timeSet => {
      row[String(timeSet.VehicleId)] =
        onTimeStatus(timeSet.OnTimeStatus) + " " + timeSet.Text;
    });
    return row;
  });

  function onTimeStatus(status) {
    switch (status) {
      case 0:
        return '<div class="ots on-time">OT</div>';
        break;
      case 2:
        return '<div class="ots early">ER</div>';
        break;
      case 3:
        return '<div class="ots late">LT</div>';
        break;
    }
  }

  function nextStop(timeText) {
    if (timeText === "Arriving" || timeText === "1 min") return "next-stop";
    return "";
  }

  function vsort(a, b) {
    return (
      a.VehicleId - b.VehicleId ||
      String(a.VehicleId).localeCompare(String(b.VehicleId))
    );
  }
</script>

<style>
  :global(.ots) {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
    padding: 2px 5px;
    border: 1px solid white;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
  }
  :global(.on-time) {
    background: green;
    color: white;
  }
  :global(.early) {
    background: yellowgreen;
    color: black;
  }
  :global(.late) {
    background: orange;
    color: black;
  }
  .next-stop {
    background-color: aquamarine;
    color: black;
  }
</style>

{#if myRoute.IsRunning}
  <h3>Route Time Status</h3>
  {#if numberOfVehiclesAT === 1}There is one bus serving this route.{/if}
  {#if numberOfVehiclesAT > 1}
    There are {numberOfVehiclesAT} buses serving this route.
  {/if}
  <DataTable {columns} {rowData} />
{/if}
